'use client'

import { useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/material/styles'

export function useMedia() {
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'))
  const isTablet = useMediaQuery(theme.breakpoints.between('md', 'lg'))
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  return {
    isMobile,
    isTablet,
    isDesktop,
  }
}
